import { render, staticRenderFns } from "./RoomEdit.vue?vue&type=template&id=25539504&scoped=true"
import script from "./RoomEdit.vue?vue&type=script&lang=js"
export * from "./RoomEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25539504",
  null
  
)

export default component.exports